<script lang="ts" setup>
/**
 * 投稿完了画面の表示。
 */
</script>

<template>
	<div class="revico-community-talk-post-complete">
		<font-awesome-icon icon="fa-solid fa-circle-check" />

		<slot name="contents"></slot>
	</div>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	.revico-community-talk {
		&-post-complete {
			text-align: center;
			white-space: pre-wrap;

			.fa-circle-check {
				display: block;
				margin: 0 auto 12px auto;
				font-size: 3em;
				opacity: 0.4;
			}
		}
	}
}
</style>
